import { Model } from '@vuex-orm/core'
import Fee from '@/models/Fee'
import Configuration from '@/models/Configuration'

export default class ConfigurationFee extends Model {
  declare value: number
  declare configurationId: string
  declare feeId: string
  declare fee: Fee
  declare configuration: Configuration

  static entity = 'configurationFees'

  static primaryKey = ['feeId', 'configurationId']

  static fields() {
    return {
      value: this.number(0),
      configurationId: this.attr(null),
      feeId: this.attr(null),
      fee: this.belongsTo(Fee, 'feeId'),
      configuration: this.belongsTo(Configuration, 'configurationId')
    }
  }
}
